import React from 'react'
import { required } from 'react-admin'
import { CustomFormProps } from 'types/common'
import LastEditDetailsField from 'ui-shared/FormComponents/LastEditDetailsFields'
import LocalizedInputText from 'ui-shared/LocalizedFields/LocalizedInputText'
import { KSimpleForm } from 'ui-shared/WrappedInputs/KSimpleForm'

export type KFormValidator = unknown | unknown[]

export type CatalogItemBaseFormProps = CustomFormProps & {
  facetFields?: React.ReactElement
  slotBeforeFacets?: React.ReactElement
  validate?: KFormValidator
}

const CatalogItemBaseForm: React.FC<CatalogItemBaseFormProps> = ({
  facetFields,
  slotBeforeFacets,
  children,
  ...props
}) => {
  return (
    <KSimpleForm {...props}>
      <LastEditDetailsField />
      <LocalizedInputText
        source="name"
        label="form.fields.name"
        validate={required()}
        fullWidth
      />
      {slotBeforeFacets}
      {facetFields}
      {children}
    </KSimpleForm>
  )
}

export default CatalogItemBaseForm
